module.exports = __webpack_public_path__ + "static/media/downarrow.a8692c55.svg";